var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.641 4.23129C13.4368 4.06252 13.1742 3.98127 12.9104 4.00524C12.6467 4.0292 12.403 4.15643 12.2326 4.35922L8 9.43764L3.76734 4.35931C3.59742 4.15572 3.3536 4.02797 3.08949 4.00416C2.82539 3.98035 2.56265 4.06243 2.35906 4.23235C2.15548 4.40226 2.02773 4.64609 2.00392 4.91019C1.98011 5.17429 2.06219 5.43704 2.2321 5.64062L7.23239 11.6409C7.32619 11.7534 7.44357 11.8439 7.57621 11.906C7.70886 11.9681 7.85354 12.0003 8 12.0003C8.14647 12.0003 8.29114 11.9681 8.42379 11.906C8.55644 11.8439 8.67382 11.7534 8.76762 11.6409L13.7679 5.64054C13.9378 5.43675 14.0198 5.17388 13.996 4.90965C13.9722 4.64542 13.8445 4.40144 13.641 4.23129Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b8dbd2a68f25f06c7d51ea914597d422.svg";
export { ForwardRef as ReactComponent };